export { styleSingleton } from './component';
export { stylesheetSingleton } from './singleton';
export { styleHookSingleton } from './hook';



//////////////////
// WEBPACK FOOTER
// ./~/react-style-singleton/dist/es2015/index.js
// module id = 755
// module chunks = 2